module.exports = __webpack_public_path__ + "static/media/backgroundimage2dark.f1738884.png";